import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../../lib/loopback'

const referenciaTransportadoraRepository = createRepository({
  path: 'transportadoras-confiavel',
  restApi,
  queryTransform: {
    nome: query.ilike('nome'),
    ...paginate
  }
})
export default referenciaTransportadoraRepository
